import moment from 'moment'
import { nextTick, computed, watch } from "vue";
import store  from '@/store'
import axios from 'axios'
import { ElMessage } from "element-plus";
/**
 * 导出函数
 */
  interface exportHeaderConfig {
    label: string,
    keyName: string | number
  }
 const  export_col_val_cov_fn = (diy_datas:any, table_datas:any, key:any) => {
    table_datas.forEach((item:any) => {
      diy_datas.forEach((diy_item:any) => {
        if(item[key] === diy_item.key) {
          item[key] = diy_item.value
        }
      });
    });
  }
  // 导出数据日期格式化
 const export_col_val_cov_date_fn = (table_datas:any, key:any) => {
    table_datas.forEach((item:any) => {
        item[key] = item[key] ? moment(item[key] * 1000).format('YYYY-MM-DD HH:mm:ss') : ''
    });
  }
  // 导出按钮点击
   const export_fn = (headerConfig:Array<exportHeaderConfig>,infoList:any,title = '测试表格') => {
    import('@/vendor/Export2Excel').then(excel => {
      let t_headers:any = [],  // 头部展示
          fiter_keys :any= [],  // 字段名
          table_datas = JSON.parse(JSON.stringify(infoList))
          headerConfig.forEach((item:any) => {
        t_headers.push(item.label)
        fiter_keys.push(item.keyName)
        // 展示数据参考Table自定义数据配置项进行转换
        if(item.diy_datas && item.diy_datas.length > 0) {
          export_col_val_cov_fn(item.diy_datas, table_datas, item.prop)
        }
        // 日期格式转换
        if(item.type === 'date') {
          export_col_val_cov_date_fn(table_datas, item.prop)
        }
      });

      const list = table_datas
      const data = formatJson(fiter_keys, list)
      excel.export_json_to_excel({
        header: t_headers,
        data,
        filename: title, //表格名称
        bookType: 'xlsx' // 类型
      })
      // this.downloadLoading = false
    })
  }
// 取子级数据
const getDatas = (obj: object, key_name: string) => {
  let keys = key_name.split('.')
  let sll_item = null
  for (let i = 0; i < keys.length; i++) {
    if(sll_item) {
      sll_item = sll_item[keys[i]]
    }
    else {
      sll_item = obj[keys[i]]
    }
  }
  return sll_item
}
  // 导出格式化数据
 const formatJson = (filterVal:any, jsonData:any) => {
    return jsonData.map((v:any) => filterVal.map((j:any) => {
      if (j === 'timestamp') {
        return parseTime(getDatas(v, j))
      } else {
        return getDatas(v, j)
      }
    }))
  }
  function parseTime(time:any, cFormat?:any) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result:any, key:any) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  }

const chat_init_fn = () => {
  const language = computed(() => {
    return store.getters.language
  })
  watch(() => language.value , () => {
    let body = document.querySelector('body')
    let chat_obj: HTMLElement = document.querySelector('.cn_chat_div')
    chat_obj.style.display = 'none'
    if(language.value === 'en') {
      body.className = 'lan_en_body'
    } else {
      body.className = ''
      chat_obj.style.display = 'block'
    }
  }, {immediate: true})
  
}
// 导出文档流 表格
const exportDocumentFlow = async(url,params,name)=>{
  try {
    const res = await axios.get(url, {
          headers: {
            Authorization: 'Bearer ' + store.getters.token,
            // 'x-authenticated-userid':1
          },
          params: params,
          responseType: 'blob'
        })

        const BLOB: any = res.data// Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
        const fileReader = new FileReader() // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
        fileReader.readAsDataURL(BLOB) // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
        fileReader.onload = (event) => { // 处理load事件。该事件在读取操作完成时触发
        // 新建个下载的a标签，完成后移除。
          const a:any = document.createElement('a')
          a.download = `${name}.xlsx`
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
  } catch (error) {
    ElMessage.error(error.message);
  } finally {
    return true
  }
  
}
export {
  export_fn,
  chat_init_fn,
  exportDocumentFlow
}